import React from 'react';
import {
  ContentCardSkeleton,
  ContentComparisonHeader,
  NoRoundedBottomContentCardSkeleton
} from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/components/ContentComparisonCard';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Box, Divider } from '@mui/material';
import colors from 'src/utils/colors';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { IconReloadingDisabled } from 'src/components/BeaconV2Components/icons';
import ButtonDropdown from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/ButtonDropdown';

export const AllBulletsComparisonSkeleton = () => {
  const bulletCount = 5;
  const bulletIndices = Array.from({ length: bulletCount }, (_, i) => i);

  return (
    <>
      {bulletIndices.map((index) => (
        <React.Fragment key={`bullet-skeleton-${index}`}>
          <Flex gap={16}>
            <ContentCardSkeleton title={`Bullet ${index + 1}`} />
            <ContentCardSkeleton title={`Bullet ${index + 1}`} />
          </Flex>
          <Divider sx={{ margin: '32px 0px' }} />
        </React.Fragment>
      ))}
    </>
  );
};

export const ContentGenSingleReviewSkeleton = () => {
  return (
    <>
      <ContentComparisonHeader />
      <Flex gap={16}>
        <ContentCardSkeleton title="Title" />
        <ContentCardSkeleton title="Title" />
      </Flex>
      <Divider sx={{ margin: '32px 0px' }} />
      <AllBulletsComparisonSkeleton />
      <Flex gap={16}>
        <ContentCardSkeleton title="Description" flexHeight="828px" boxHeight="752px" />
        <NoRoundedBottomContentCardSkeleton title="Description" flexHeight="828px" boxHeight="752px" />
      </Flex>
      <Flex
        justifyContent="space-between"
        sx={{
          marginTop: '64px'
        }}
      >
        <Flex gap={16}>
          <SlButton
            buttonSx={{
              border: `1px solid ${colors.graysSecondary}`
            }}
            disabled={true}
          >
            Back
          </SlButton>
          <SlButton>Archive content</SlButton>
        </Flex>

        <Flex gap={16}>
          <SlButton variant="normal" disabled={true}>
            Export
          </SlButton>
          <ButtonDropdown
            label="Save content"
            options={[
              { id: 'saveToLibrary', label: 'Save to library' },
              { id: 'saveToMaster', label: 'Save to master' }
            ]}
            onChange={() => {}}
            variant="contained"
            disabled={true}
          />
          <SlButton variant="contained" disabled={true}>
            Next
          </SlButton>
        </Flex>
      </Flex>
    </>
  );
};
